import { render, staticRenderFns } from "./serviceApp.vue?vue&type=template&id=582f841b&scoped=true&"
import script from "./serviceApp.vue?vue&type=script&lang=js&"
export * from "./serviceApp.vue?vue&type=script&lang=js&"
import style0 from "./serviceApp.vue?vue&type=style&index=0&id=582f841b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582f841b",
  null
  
)

export default component.exports